import * as React from 'react';

import { UIText2 } from '@cian/ui-kit';
import * as styles from './SingleContactWrapper.css';

interface ISingleContactWrapperProps {
  description: string | null;
}

export const SingleContactWrapper = ({
  children,
  description,
}: React.PropsWithChildren<ISingleContactWrapperProps>) => {
  return (
    <div className={styles['container']}>
      {description && (
        <div className={styles['description']}>
          <UIText2 color="gray60_100">{description}</UIText2>
        </div>
      )}
      {children}
    </div>
  );
};
